"use strict";
module.exports = require('./en');



//////////////////
// WEBPACK FOOTER
// ./~/date-names/index.js
// module id = 444
// module chunks = 1